import React, { memo, Suspense } from "react";
import styles from "./PreLogin.module.scss";
import { Outlet } from "react-router-dom";
import Loader from "@/components/Loader/Loader";
import bgImage from "@/assets/png/loginBg.png";

const PreLogin = () => {
  return (
    <div
      className={styles.mainContainer}
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <Suspense fallback={<Loader />}>
        <span className={styles.childrenContainer}>
          <Outlet />
        </span>
      </Suspense>
    </div>
  );
};

export default memo(PreLogin);
